import { useEffect } from "react";
import {
    Autocomplete,
    Box,
    Button,
    TextField,
    Typography,
    alpha,
} from "@mui/material";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DataGrid, GridApi, GridCellValue, GridColDef, gridClasses } from '@mui/x-data-grid';
import Divider from '@mui/material/Divider';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { styled } from '@mui/material/styles';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppSelector, useAppDispatch } from "../../hooks";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { IPurchaseOrderDetail, IPurchaseOrderDetails } from "../../interfaces/PurchaseOrder/IPurchaseOrderDetail";
import { setPurchaseOrderDetail, setPurchaseOrderDetails } from "../../slices/purchaseOrderDetailSlice";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";


const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

const handleSubmitD = () => console.log('Okay')

const ODD_OPACITY = 0.2;

const steps = ['Phase 1', 'Phase 2'];

const columns: GridColDef[] = [
    { field: 'itemName', headerName: 'Sales Order Number', width: 230 },
    { field: 'itemName', headerName: 'Item Name', width: 230 },
    { field: 'description', headerName: 'Item Cost Per Unit', width: 230, editable: true },
    { field: 'allocatedSpace1', headerName: 'Unit Type', width: 230, editable: true },
    { field: 'availableSpace2', headerName: 'Item Description', width: 230 },
    { field: 'availableSpace3', headerName: 'Number of Trailers Loads', width: 230 },
    { field: 'availableSpace4', headerName: 'Shipment Type', width: 230, editable: true },
    { field: 'availableSpace5', headerName: 'Units Received', width: 230, editable: true },
    { field: 'availableSpace6', headerName: 'Shipment Date', width: 230, editable: true, type:'date' },
    { field: 'availableSpace7', headerName: 'Received Date', width: 230, editable: true, type:'date' },
    {
        field: "action",
        headerName: "Action",
        sortable: false,
        renderCell: (params) => {
          const onClick = (e: { stopPropagation: () => void; }) => {
            e.stopPropagation(); // don't select this row after clicking
    
            const api: GridApi = params.api;
            const thisRow: Record<string, GridCellValue> = {};
    
            api
              .getAllColumns()
              .filter((c) => c.field !== "__check__" && !!c)
              .forEach(
                (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
              );
    
            return alert(JSON.stringify(thisRow, null, 4));
          };
    
          return <Button variant="outlined" color="secondary">RECEIVED</Button>;
        }
      },
];

interface WorkLogRow {
    description: string,
    material: string,
    size: string,
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const chemicalTypes = ["Acid", "Chemical", "Fertilizer"];

type Props = {
    setTabValue: React.Dispatch<React.SetStateAction<number>>,
    setAllowReview: React.Dispatch<React.SetStateAction<boolean>>,
    hideButtons: boolean,
}

export default function PoByOrderDetails(props: Props) {
    const { setTabValue, setAllowReview, hideButtons } = props;
    const [openSuccess, setSuccess] = React.useState(false);

    const dispatch = useAppDispatch();
    const currentPurchaseOrderDetail = useAppSelector((state) => state.purchaseOrderDetails.purchaseOrderDetail);
    const currentPurchaseOrderDetails = useAppSelector((state) => state.purchaseOrderDetails.purchaseOrderDetails);

    useEffect(() => {
        let appState: IApplication = {
            pageTitle: "Purchase Order - By Order",
            backgroundPath: "/assets/images/inventorybg.jpg"
        }
        dispatch(setPageTitle(appState));
        if (currentPurchaseOrderDetail != null) {
            reset(currentPurchaseOrderDetail);
        }

        axios.get<IPurchaseOrderDetail[]>(`${process.env.REACT_APP_ENDPOINT}/api/PurchaseOrderDetails`).then((resp) => {
            setRows(resp.data);
        })


    }, []);

    const [orderType, setOrderType] = React.useState<string | null>('');

    const types = ['Normal', 'Chemical'];
    const shippingTypes = ['Vendor Ship', 'Grower Truck'];
    const unitTypes = ['Bale', 'Pallet', 'Box'];

    useEffect(() => {

    }, [orderType]);

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#191919' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: 0,
        borderRadius: 0,
        boxShadow: "none",
        backgroundImage: "none",

    }));

    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.row}.even`]: {
            backgroundColor: theme.palette.success.dark,
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
                '@media (hover: none)': {
                    backgroundColor: 'green',
                },
            },
            '&.Mui-selected': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY + theme.palette.action.selectedOpacity,
                ),
                '&:hover, &.Mui-hovered': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY +
                        theme.palette.action.selectedOpacity +
                        theme.palette.action.hoverOpacity,
                    ),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: alpha(
                            theme.palette.primary.main,
                            ODD_OPACITY + theme.palette.action.selectedOpacity,
                        ),
                    },
                },
            },
        },
    }));


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const { register, handleSubmit, control, formState: { errors }, getValues, reset } = useForm<IPurchaseOrderDetail>();
    const onSubmit: SubmitHandler<IPurchaseOrderDetail> = data => {
        console.log("DETAIL DATA", data);
        dispatch(setPurchaseOrderDetail(data))
        dispatch(setPurchaseOrderDetails([...currentPurchaseOrderDetails, data]));
    };

    const [rows, setRows] = React.useState<IPurchaseOrderDetails>([]);

    return (
        <Box id="mainForm" component="form">
            <Grid container spacing={0}>
                <Grid item xs={12} bgcolor='rgba(255, 255, 255, 1)'>
                    <Grid container spacing={0} >
                        <Grid item xs={12}>
                            <Grid container spacing={1} padding={3}>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}>
                                        <Controller
                                            control={control}
                                            name="type"
                                            render={({ field: { ref, onChange, ...field } }) => (
                                                <Autocomplete
                                                    value={field.value}
                                                    defaultValue={types[0]}
                                                    options={types}
                                                    getOptionLabel={(option) => option}
                                                    onChange={(_, data) => {
                                                        setOrderType(data);
                                                        return onChange(data);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} {...field} fullWidth inputRef={ref} variant="outlined" label="Type" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                                    )}
                                                />
                                            )}
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={12}><Divider /></Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="itemname" label="Item Name" {...register("itemName")} /></Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="itemcost" label="Item Cost Per Unit" {...register("itemCost")} /></Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}>
                                        <Controller
                                            control={control}
                                            name='type'
                                            render={({ field: { ref, onChange, ...field } }) => (
                                                <Autocomplete
                                                    value={field.value}
                                                    defaultValue={unitTypes[0]}
                                                    options={unitTypes}
                                                    getOptionLabel={(option) => option}

                                                    onChange={(_, data) => {
                                                        setOrderType(data);
                                                        return onChange(data);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} {...field} fullWidth inputRef={ref} variant="outlined" label="Unit Type" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                                    )}
                                                />
                                            )}
                                        />
                                    </Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="itemdescription" label="Item Description" {...register("itemDescription")} /></Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="outlined" fullWidth id="quantity" label="Number of Trailer Loads"  {...register("quantity")} /></Item>
                                </Grid>
                                <Grid item xs={4}>
                                    <Item sx={{ bgcolor: 'transparent' }}>
                                        <Controller
                                            control={control}
                                            name='shippingType'
                                            render={({ field: { ref, onChange, ...field } }) => (
                                                <Autocomplete
                                                    value={field.value}
                                                    defaultValue={shippingTypes[0]}
                                                    options={shippingTypes}
                                                    getOptionLabel={(option) => option}

                                                    onChange={(_, data) => {
                                                        setOrderType(data);
                                                        return onChange(data);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} {...field} fullWidth inputRef={ref} variant="outlined" label="Shipping Type" sx={{ fontSize: '24px', fontWeight: '900' }}></TextField>
                                                    )}
                                                />
                                            )}
                                        />
                                    </Item>
                                </Grid>
                                <Grid xs={12} height={'60vh'}>
                                    <StripedDataGrid
                                        rows={rows}
                                        columns={columns}
                                        editMode="row"
                                        pageSize={20}
                                        rowsPerPageOptions={[20]}
                                        checkboxSelection
                                        sx={{ borderColor: 'rgba(100,100,100,0.2)', minHeight: '50vh' }}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                        }
                                    />
                                </Grid>
                                {!hideButtons && <Grid item xs={6}>
                                    <Button
                                        fullWidth
                                        onClick={() => { handleSubmit(onSubmit)(); setTabValue(0); }}
                                        variant="contained"
                                        color="primary"
                                        sx={{ p: 2 }}
                                        size="large"
                                        endIcon={<CheckCircleIcon />}
                                    >
                                        <Typography variant="h5">
                                            Go Back
                                        </Typography>
                                    </Button>
                                </Grid>}

                                {!hideButtons && <Grid item xs={6} >
                                    <Button
                                        fullWidth
                                        onClick={() => { handleSubmit(onSubmit)(); setAllowReview(true); setTabValue(2); }}
                                        variant="contained"
                                        color="secondary"
                                        sx={{ p: 2 }}
                                        size="large"
                                        endIcon={<CheckCircleIcon />}
                                    >
                                        <Typography variant="h5">
                                            Review
                                        </Typography>
                                    </Button>
                                </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}